import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  loading,
  cancelText = "Cancel",
  confirmText = "Confirm",
}: any) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 !mt-0">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-xl">
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        <p className="text-sm text-gray-600">{message}</p>
        <div className="grid grid-cols-2 gap-3 pt-4">
          <ButtonSecondary variant="cancel" onClick={onClose} disabled={loading}>
            {cancelText}
          </ButtonSecondary>
          <ButtonPrimary
            sizeClass="sm"
            onClick={() => {
              onConfirm();
            }}
            loading={loading}
          >
            {!loading && confirmText}
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
